import type {ISerializer, JsonType} from "dcerialize/dist/types";
import {DateTime} from "luxon";
import type {Optional} from "./TypeHelpers";

// eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
function _canDeserializeDate(data: Readonly<JsonType>): data is string {
  return typeof data === "string";
}

export const DateTimeSerializer: ISerializer<Optional<DateTime>> = {
  Serialize(target: Optional<DateTime>): JsonType {
    return target?.toISO({suppressMilliseconds: true}) ?? null;
  },
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  Deserialize(data: Readonly<JsonType>): Optional<DateTime> {
    return _canDeserializeDate(data) ? DateTime.fromISO(data) : undefined;
  },
};

export const DateOnlySerializer: ISerializer<Optional<DateTime>> = {
  Serialize(target: Optional<DateTime>): JsonType {
    return target?.toISODate() ?? null;
  },
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  Deserialize(data: Readonly<JsonType>): Optional<DateTime> {
    return _canDeserializeDate(data) ? DateTime.fromISO(data) : undefined;
  },
};

export const TimeOnlySerializer: ISerializer<Optional<DateTime>> = {
  Serialize(target: Optional<DateTime>): JsonType {
    return target?.toISOTime() ?? null;
  },
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  Deserialize(data: Readonly<JsonType>): Optional<DateTime> {
    return _canDeserializeDate(data) ? DateTime.fromISO(data) : undefined;
  },
};

export const ZonelessTimeOnlySerializer: ISerializer<Optional<DateTime>> = {
  Serialize(target: Optional<DateTime>): JsonType {
    return target?.toISOTime({includeOffset: false}) ?? null;
  },
  // eslint-disable-next-line @typescript-eslint/prefer-readonly-parameter-types
  Deserialize(data: Readonly<JsonType>): Optional<DateTime> {
    return _canDeserializeDate(data) ? DateTime.fromISO(data) : undefined;
  },
};
